import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { ClaimsFilters } from './claims.types';
import { loaders } from './claims.loaders';
import { converters } from './claims.converters';

export const claimsKeys = queryKeyFactory('claims');

export const useClaims = (filters: Partial<ClaimsFilters> = {}) => {
  return useQuery({
    queryKey: claimsKeys.list(filters),
    queryFn: () => loaders.getClaims({ filters }),
    select: converters.getClaims,
  });
};

export const useClaim = (claimId: string) => {
  return useQuery({
    queryKey: claimsKeys.detail(claimId),
    queryFn: () => loaders.getClaim({ claimId }),
    select: converters.getClaim,
  });
};
